// extracted by mini-css-extract-plugin
module.exports = {"appSelectLabel":"AppSelect_appSelectLabel__TzgV2","appSelectField":"AppSelect_appSelectField__2v4iD","appSelectErrorMessage":"AppSelect_appSelectErrorMessage__gswG4"};